import styled from "styled-components";

export const TargetLine = styled.div<{ color: string }>`
    position: absolute;
    top: 0;
    width: 1px;
    height: 8px;
    background-color: ${(props) => props.color};
    box-shadow:
        0 0 0 0.5px rgba(0, 0, 0, 0.85),
        0 0 2px ${(props) => props.color};
    opacity: 1;
    transition: left 1s ease;
`;
